// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const SectionIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 58 58">
          <path d="M29 2.96C12.984 2.96 0 14.62 0 29c0 14.38 12.984 26.04 29 26.04S58 43.38 58 29C58 14.62 45.016 2.96 29 2.96zm0 45.927c-11.708 0-21.198-8.438-21.198-18.844 0-3.614 1.146-6.988 3.13-9.856 4.494-2.733 10.36-4.97 17.528-4.97 7.92 0 14.384 2.732 19.182 5.846 1.63 2.67 2.557 5.728 2.557 8.98-.002 10.406-9.495 18.844-21.2 18.844z"/>
          <path d="M34.61 27.32a4.728 4.728 0 0 1-2.302-8.854 9.156 9.156 0 0 0-13.005 8.31 9.156 9.156 0 1 0 18.31 0c0-.176-.004-.35-.015-.522a4.692 4.692 0 0 1-2.987 1.067z"/>
        </svg>
      )
    }
  </Icon>
);

export default SectionIcon;
